import React from "react";

export const Logo = ({ className = "", showText = true, testId = "brand-logo" }) => {
  return (
    <span className={`inline-flex items-center gap-3 ${className}`} data-testid={testId}>
      <svg width="34" height="34" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <rect x="1" y="1" width="38" height="38" stroke="#C8A45A" strokeWidth="1.2" />
        <path d="M8 28V12L20 22L32 12V28" stroke="#C8A45A" strokeWidth="1.6" strokeLinejoin="round" strokeLinecap="round" />
        <path d="M20 22V30" stroke="#C8A45A" strokeWidth="1.6" strokeLinecap="round" />
      </svg>
      {showText && (
        <span className="font-display leading-none">
          <span className="text-white text-lg font-semibold tracking-[0.14em]">ET PRIME</span>
        </span>
      )}
    </span>
  );
};

export default Logo;
